import { render } from "./FormKredit.vue?vue&type=template&id=44ed617a&scoped=true"
import script from "./FormKredit.vue?vue&type=script&lang=js"
export * from "./FormKredit.vue?vue&type=script&lang=js"

import "./FormKredit.vue?vue&type=style&index=0&id=44ed617a&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ed617a"]])

export default __exports__